import { FirebaseError } from 'firebase/app';
import { Functions, FunctionsInstances, httpsCallable } from '@angular/fire/functions';
import { from, Observable, throwError, firstValueFrom } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from './configuration/configuration.service';
import { AuthenticationService } from './authentication.service';
import { inject } from '@angular/core';
import { ControllerService } from './controller/controller.service';

export abstract class DataService {
  protected functions: Functions;
  protected configurationService: ConfigurationService = inject(ConfigurationService);
  protected functionsInstances: FunctionsInstances = inject(FunctionsInstances);
  protected controllerService: ControllerService = inject(ControllerService);
  constructor() {
    this.functions = this.functionsInstances[0];
    this.createFunctions();
  }

  protected abstract createFunctions(): void;

  protected callFunction<T, R>(name: string, data: T): Observable<R> {
    const callable = httpsCallable<T, R>(this.functions, name);
    return from(callable(data)).pipe(
      map(result => result.data as R),
      catchError(error => this.handleFunctionError(error))
    );
  }

  protected async callFunctionAsync<T, R>(name: string, data: T): Promise<R> {
    return firstValueFrom(this.callFunction<T, R>(name, data));
  }

  private handleFunctionError(error: any) {
    if (this.isFirebaseError(error)) {
      switch (error.code) {
        case 'deadline-exceeded':
          alert('The request timed out. Please try again.');
          break;
        case 'unavailable':
          alert('The service is currently unavailable.');
          break;
        case 'permission-denied':
          alert('You do not have access to this resource.');
          break;
        default: {
          console.error(error);
          // this.controllerService.toastError(error.message).then(toast => toast.present());
        }
      }
    } else {
      console.error('Unexpected error:', error);
      alert('An unexpected error occurred.');
    }
    return throwError(() => error);
  }

  private isFirebaseError(error: any): error is FirebaseError {
    return error?.name === 'FirebaseError' && typeof error.code === 'string';
  }
}
